import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import React, { useEffect, useState } from "react";

import { showMessage, getToken, random_rgba } from "../../Functionalities/Functions";
import axios from "axios";
import { protocol } from "../../Functionalities/Config";

import FilterComponent from "../../CoreComponents/FilterComponent";
import { ManageManagers } from "./Logic";
import LoadingComponent from "../../CoreComponents/LoadingComponent";

function Body() {
  const [editData, setEditData] = useState({
    manager_id: "",
    is_blocked: "",
    keyword: "",
  });
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true)
  const clearHandler = () => {
    setData({
      ...data,
      id: "",
      name: "",
    });
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    // showMessage("Loading reviews", "info", "Loading", "bottom", "bottom-left", 0);
    let result = ManageManagers("", "", "get", "branch_managers=true");
    result
      .then((result) => {
        setData({
          ...data,
          data: result.data.results,
        });
        setLoading(false)
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  return (
    <div className="content-body">
      { !loading ?
        <div className="container-fluid">
          <FilterComponent
            handleNext={handleNext}
            handlePrev={handlePrev}
            next={next}
            prev={prev}
            addItemName={"Add Manager"}
            // modalButton={true} // for Modal
            addItemPath={"/addmanager"} // for a page
          />
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-responsive-lg mb-0 table-striped">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Blocked</th>
                        </tr>
                      </thead>
                      <tbody id="customers">
                        {data.data.length > 0 &&
                          data.data.map((customer) => {
                            return (
                              <tr className="btn-reveal-trigger">
                                <td className="py-2">FDRMNR{customer.id}</td>
                                <td className="py-3">
                                  <a href={`/manager/${customer.id}`}>
                                    <div className="media d-flex align-items-center">
                                      <div className="avatar avatar-xl mr-2">
                                        <div
                                          // className="rounded-circle img-fluid"
                                          style={{
                                            background: random_rgba(),
                                            width: 40,
                                            height: 40,
                                            borderRadius: 20,
                                            // textAlign: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <h5 className="mb-0 fs--1">
                                            {customer.first_name
                                              .charAt(0)
                                              .toUpperCase()}
                                          </h5>

                                          {/* <span
                                            style={{ color: "#FFF" }}
                                          ></span> */}
                                        </div>
                                      </div>
                                      <div className="media-body">
                                        <h5 className="mb-0 fs--1">
                                          {" "}
                                          {customer.first_name}
                                        </h5>
                                      </div>
                                    </div>
                                  </a>
                                </td>
                                <td className="py-2">
                                  <a href={`/manager/${customer.id}`}>
                                    {customer.email ? customer.email : 'No email'}
                                  </a>
                                </td>
                                <td className="py-2">
                                  {" "}
                                  <a href="tel:2012001851">
                                    {customer.details.mobile}
                                    {/* {customer.details?customer.details.mobile:'No number'} */}
                                  </a>
                                </td>
                                <td>
                                     {customer.details.is_blocked ? 'Yes':'No'} 
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        : <LoadingComponent />
      }
    </div>
  );
}

function Managers() {
  const header = "";

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Managers"} subHeading={"All managers under foodoor"} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Managers;
